import { ResidentialComponent } from "./content-area/residential/residential.component";
import { CommercialComponent } from "./content-area/commercial/commercial.component";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AgentProfilePageComponent } from "./content-area/agent-profile-page/agent-profile-page.component";
import { AllListingsComponent } from "./content-area/all-listings/all-listings.component";
import { ContactComponent } from "./content-area/contact/contact.component";
import { HomePageComponent } from "./content-area/home-page/home-page.component";
import { IndividualListingComponent } from "./content-area/individual-listing/individual-listing.component";
import { LocationsPageComponent } from "./content-area/locations-page/locations-page.component";
import { OurCompanyComponent } from "./content-area/our-company/our-company.component";
import { OurTeamComponent } from "./content-area/our-team/our-team.component";
import { SearchResultsComponent } from "./content-area/search-results/search-results.component";
import { IndividualCommercialComponent } from "./content-area/individual-commercial/individual-commercial.component";
import { ViewBlogComponent } from "./content-area/view-blog/view-blog.component";
import { BlogPageComponent } from "./content-area/blog-page/blog-page.component";
import { PrivacyPolicyComponent } from "./content-area/privacy-policy/privacy-policy.component";
const routes: Routes = [
  { path: "", component: HomePageComponent },
  { path: "company", component: OurCompanyComponent },
  { path: "our-team", component: OurTeamComponent },
  { path: "contact", component: ContactComponent },
  { path: "privacy", component: PrivacyPolicyComponent },
  { path: "blog-page", component: BlogPageComponent },
  { path: "search-results", component: SearchResultsComponent },
  { path: "listing/:listing_id", component: IndividualListingComponent },
  {
    path: "listings-com/:listing_id",
    component: IndividualCommercialComponent,
  },
  { path: "commercial", component: CommercialComponent },
  { path: "residential", component: ResidentialComponent },
  //{path : "all-listings", component: AllListingsComponent},
  { path: "location/:state", component: LocationsPageComponent },
  { path: ":team-member-name", component: AgentProfilePageComponent },
  { path: "blog/:blogId", component: ViewBlogComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
